import React from 'react'
import { useState } from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FilterButtonStatus from './FilterButtonStatus';

export default function FilterPopupTrafficRegulation(props) {
    const [checkedTypes, setCheckedTypes] = useState(props.filters.applicationStatus);
    const [date_str, setDate_str] = useState(props.filters.applicationDate_str);
    const [date_end, setDate_end] = useState(props.filters.applicationDate_end);
    const [date2_str, setDate2_str] = useState(props.filters.restrictedDateTime_str);
    const [date2_end, setDate2_end] = useState(props.filters.restrictedDateTime_end);
    function onClearClick() {
        setCheckedTypes([]);
        setDate_str("");
        setDate_end("");
        setDate2_str("");
        setDate2_end("");
    }

    const handleClose = () => {
        var isSearch =false;

        if(date_str !== props.filters.applicationDate_str || date_end !== props.filters.applicationDate_end){
            props.onApplyFilter_noSearch("applicationDate_str",date_str);
            props.onApplyFilter_noSearch("applicationDate_end",date_end);
            isSearch = true;
        }

        if (checkedTypes !== undefined && props.filters.applicationStatus !== undefined && !stringArrayEquals(props.filters.applicationStatus, checkedTypes)) {
            props.onApplyFilter_noSearch("applicationStatus",checkedTypes);
            isSearch = true;
        }

        if(date2_str !== props.filters.restrictedDateTime_str || date2_end !== props.filters.restrictedDateTime_end){
            props.onApplyFilter_noSearch("restrictedDateTime_str",date2_str);
            props.onApplyFilter_noSearch("restrictedDateTime_end",date2_end);
            isSearch = true;
        }

        //いずれかのフィルターが変更されていた場合は、検索する
        if(isSearch){
            props.onSearch();
        }
        
        props.onClose();
    };

    return (
        <ClickAwayListener onClickAway={handleClose}>
        <div role="dialog" className="hovercard noprint">
                <div className="hovercard-content hovercard-content-group">
                    <div >申請日<i className="bi bi-caret-down-fill"></i></div>
                    <div className="hovercard-Date" style={{margin:"3px 0"}}>
                        <input type="date"
                            value={date_str}
                            onChange={(e)=>setDate_str(e.target.value)}
                            max={date_end}
                        />
                        <span style={{margin:'0 5px'}}>～</span>
                        <input type="date"
                            value={date_end}
                            onChange={(e)=>setDate_end(e.target.value)}
                            min={date_str}
                        />
                    </div>
                </div>
                <div className="hovercard-content hovercard-content-group">
                    <div>
                        <div>ステータス<i className="bi bi-caret-down-fill"></i></div>
                        <FilterButtonStatus label="ステータス"
                            userAuthorities={props.userAuthorities}
                            keyword={props.keyword}
                            filters={props.filters}
                            width={props.width}
                            height={props.height}
                            anchorRef={props.anchorRef}
                            updateShowFiltersInfo={props.updateShowFiltersInfo}
                            viewtype={props.viewtype}
                            isMobileMode={props.isMobileMode}
                            onApplyFilter={props.onApplyFilter}
                            onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                            onClick={props.onSearchFilterClick}
                            
                            isDisabled={false}
                            isShow={true}
                            isReport={false}
                            masterKind={'applicationStatus'}
                            filterKind={'applicationStatus'}
                            targetTypes={checkedTypes}
                            setCheckedTypes={setCheckedTypes}
                            />
                    </div>
                </div>
                <div className="hovercard-content hovercard-content-group">
                    <div >規制期間<i className="bi bi-caret-down-fill"></i></div>
                    <div className="hovercard-Date" style={{margin:"3px 0"}}>
                        <input type="date"
                            value={date2_str}
                            onChange={(e)=>setDate2_str(e.target.value)}
                            max={date2_end}
                        />
                        <span style={{margin:'0 5px'}}>～</span>
                        <input type="date"
                            value={date2_end}
                            onChange={(e)=>setDate2_end(e.target.value)}
                            min={date2_str}
                        />
                    </div>
                </div>
                <div className="hovercard-buttons">
                    <button className="hovercard-button" onClick={onClearClick}>
                        <span className="hovercard-buttontext">クリア</span>
                    </button>
                    <button className="hovercard-button hovercard-lastbutton" onClick={handleClose}>
                        <span className="hovercard-buttontext hovercard-done">適用</span>
                    </button>
                </div>
            </div>
        </ClickAwayListener>
    );
}
function stringArrayEquals(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}